import moment from 'moment';
import { Dispatch } from 'redux';
import { ExpectedRealizedDTO } from '../../models/dto/ExpectedRealizedDTO';
import { PunchCardDetailsChartDTO } from '../../models/dto/PunchCardDetailsDTO';
import { api } from '../../services/api';

export const chartsActionsTypes = {
  GET_EXPECTED_REALIZED: 'GET_EXPECTED_REALIZED',
  GET_EXPECTED_REALIZED_SUCCESS: 'GET_EXPECTED_REALIZED_SUCCESS',
  GET_EXPECTED_REALIZED_FAILURE: 'GET_EXPECTED_REALIZED_FAILURE',

  GET_PUNCH_CARD_DETAILS: 'GET_PUNCH_CARD_DETAILS',
  GET_PUNCH_CARD_DETAILS_SUCCESS: 'GET_PUNCH_CARD_DETAILS_SUCCESS',
  GET_PUNCH_CARD_DETAILS_FAILURE: 'GET_PUNCH_CARD_DETAILS_FAILURE',
};

export const getExpectedRealizedChartData = (reference: number) => async (
  dispatch: Dispatch,
) => {
  try {
    dispatch({ type: chartsActionsTypes.GET_EXPECTED_REALIZED });
    const { data } = await api.get<ExpectedRealizedDTO[]>(
      `/gdp/relatorios/previstorealizado/${reference}`,
      {
        params: {
          vigencia: moment().format('YYYY-MM-DD'),
        },
      },
    );
    dispatch({
      type: chartsActionsTypes.GET_EXPECTED_REALIZED_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
    dispatch({ type: chartsActionsTypes.GET_EXPECTED_REALIZED_FAILURE });
  }
};

export const getPunchCardDetailsChartData = (reference: number) => async (
  dispatch: Dispatch,
) => {
  try {
    dispatch({ type: chartsActionsTypes.GET_PUNCH_CARD_DETAILS });
    const { data } = await api.get<PunchCardDetailsChartDTO[]>(
      `gdp/relatorios/horas-trabalhadas/${reference}`,
      {
        params: {
          periodoDe: moment()
            .subtract(1, 'month')
            .startOf('month')
            .format('YYYY-MM-DD'),
          periodoAte: moment().format('YYYY-MM-DD'),
        },
      },
    );
    dispatch({
      type: chartsActionsTypes.GET_PUNCH_CARD_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    console.log(error);
    dispatch({ type: chartsActionsTypes.GET_PUNCH_CARD_DETAILS_FAILURE });
  }
};
